import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { Button } from '@sonyged/ext-proc';

import AppContext from '../../../AppContext';
import WalkthroughVideo from '../../../../assets/videos/ice-a-field_walkthrough.mp4';

class IntroModal extends React.Component {
  static contextType = AppContext;

  componentDidMount() {
    this.context.soundController.bgmStop();
    const playPromise = this.video.play();
    if (playPromise) {
      playPromise.catch(() => {
        // Automatic playback failed
        // Do nothing
      });
    }
    this.video.addEventListener(
      'ended',
      () => {
        this.onNext();
      },
      false
    );
  }

  render() {
    return (
      <div className={`proc-video proc-root ice`}>
        <div className={'proc-background tertiary100-bg-color'}>
          <div className={'proc-outer'}>
            <div className={'proc-inner flex flex-column'}>
              <div className={'proc-contents'}>
                <video
                  ref={(r) => {
                    this.video = r;
                  }}
                  preload="auto"
                  muted={Boolean(this.props.muted)}
                  className={'w100'}
                  playsInline={true}
                  src={WalkthroughVideo}
                />
              </div>
              <Button.light onClick={this.onNext.bind(this)}>スキップ</Button.light>
            </div>
          </div>
        </div>
      </div>
    );
  }

  onNext() {
    this.props.onNextClick();
  }
}

IntroModal.propTypes = {
  onNextClick: PropTypes.func,
  muted: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return { muted: state.config.mute };
};

export default connect(mapStateToProps)(IntroModal);
